export default __webpack_public_path__ + "media/images/default-0a63f8217707d242d4061d9e75fa6703.jpg";